import { TableCell, TableRow } from '@fluentui/react-components';
import { useSharedStyles } from '../shared-styles.js';
import { useStyles } from './styles.js';

type FieldTableEmptyProps = {
    message: string;
};

export function FieldTableEmpty({ message }: FieldTableEmptyProps) {
    const styles = useStyles();
    const sharedStyles = useSharedStyles();

    return (
        <TableRow className={styles.container}>
            <TableCell className={sharedStyles.tableDisplayContents}>
                <div className={styles.emptyTable}>{message}</div>
            </TableCell>
        </TableRow>
    );
}
